import { TReturnType } from '@r1-frontend/service-engineer-visit';

import { actionTypes } from '~/src/features/full-buy/store';

export const setSlot = (slot: TReturnType | null) => ({
    type: actionTypes.SET_SLOT,
    payload: slot,
});
